import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const LanguageSwitcher = ({ className = '' }) => {
  const { language, setLanguage, t } = useLanguage();

  return (
    <label className={`inline-flex items-center ${className}`}>
      <span className="sr-only">{t('languageLabel')}</span>
      <select
        value={language}
        onChange={(e) => setLanguage(e.target.value)}
        className="h-10 rounded-full border border-brand-sand bg-white/80 px-3 text-sm font-medium text-brand-dark shadow-sm focus:outline-none focus:ring-2 focus:ring-brand-taupe/40"
        aria-label={t('languageLabel')}
      >
        <option value="en">EN</option>
        <option value="fr">FR</option>
      </select>
    </label>
  );
};

export default LanguageSwitcher;

